/* eslint-disable no-unused-vars */
export enum EmotionEnum {
  ANGRY = 'ANGRY',
  ANNOYED = 'ANNOYED',
  ANXIOUS = 'ANXIOUS',
  ARROGANT = 'ARROGANT',
  ASHAMED = 'ASHAMED',
  COLD = 'COLD',
  CONFUSED = 'CONFUSED',
  CONTEMPT = 'CONTEMPT',
  CONTENT = 'CONTENT',
  CRYING = 'CRYING',
  DISGUSTED = 'DISGUSTED',
  DOWN = 'DOWN',
  EMPTY = 'EMPTY',
  EXCITED = 'EXCITED',
  EXHAUSTED = 'EXHAUSTED',
  FUMING = 'FUMING',
  GRATEFUL = 'GRATEFUL',
  HAPPY = 'HAPPY',
  HELPLESS = 'HELPLESS',
  HURT = 'HURT',
  INDIFFERENT = 'INDIFFERENT',
  JUDGEMENTAL = 'JUDGEMENTAL',
  PROUD = 'PROUD',
  SAD = 'SAD',
  SCARED = 'SCARED',
  STRESSED = 'STRESSED',
  SURPRISED = 'SURPRISED',
  TIRED = 'TIRED',
}
